import React, {Component} from 'react';
import Styles from './style.css';
import Header from "../../components/header/component";
import cx from "classnames";
import * as Icon from "react-feather";

class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            error: false,
            success: false
        };
    };

    componentWillMount() {}

    componentDidMount() {}

    _goLink(option){
        window.open(option, '_blank');
    }

    _goInternal(option){
        window.open(option, '_self');
    }

    _contact(){
        try{
            this.props.props.history.push("/contact");
        }catch (error) {}
    }

    render() {
        return (
            <div className={Styles.footer}>
                {
                    false &&
                    <div className={Styles.footerSubscribeContainer}>
                        <div className={Styles.footerSubscribeContainerInner}>
                            <div className={Styles.footerTopContainerLeft}>
                                <input
                                    value={this.state.email}
                                    onChange={(event) => this.setState({email: event.target.value})}
                                    placeholder={"Get news! Enter your email..."}
                                    className={Styles.footerTopContainerLeftInput}/>
                                {
                                    this.state.error &&
                                    <div className={Styles.footerTopContainerLeftError}>E-mail is incorrect</div>
                                }
                                {
                                    this.state.success && !this.state.error &&
                                    <div className={Styles.footerTopContainerLeftSuccess}>Thanks!</div>
                                }
                            </div>
                            <div className={Styles.footerTopContainerRight}>
                                <div onClick={() => this._subscribe()} className={Styles.footerTopContainerRightButton}>
                                    SUBSCRIBE
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className={Styles.footerBottom}>
                    {
                        false &&
                        <div className={Styles.footerTopContainerRightMobile}>
                            <div onClick={() => this._subscribe()} className={Styles.footerTopContainerRightButton}>
                                SUBSCRIBE
                            </div>
                        </div>
                    }
                    <div className={Styles.footerBottomContainer}>
                        <div className={Styles.footerBottomContainerLeft}>
                            <div>
                                <div className={Styles.footerBottomContainerLeftTitle}>
                                    Let's make it happen
                                </div>
                                <div onClick={() => this._contact()} className={Styles.footerBottomContainerLeftItem}>
                                    TALK TO US
                                </div>
                                <div className={Styles.footerBottomContainerRightSocialContainer}>
                                    <div onClick={() => this._goInternal("mailto:swedishtechmafia@icloud.com?Subject=Hello")} className={Styles.footerBottomContainerRightSocialContainerItem}>
                                        <div className={Styles.footerBottomContainerLeftEmailIcon}>@</div>
                                    </div>
                                    <div onClick={() => this._goInternal("whatsapp://send?text=Hey Swedish Tech Mafia...&phone=+971543429986")} className={Styles.footerBottomContainerRightSocialContainerItem}>
                                        <img className={Styles.footerBottomContainerRightSocialContainerItemInstagram} src={require("../../assets/images/STM_social_whatsapp.png")}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={Styles.footerBottomContainerRight}>
                            <div>
                                <div className={Styles.footerBottomContainerRightTitle}>
                                    Find us on
                                </div>
                                <div onClick={() => this._goLink("https://www.crunchbase.com/organization/swedish-tech-mafia")} className={Styles.footerBottomContainerRightItem}>
                                    CRUNCHBASE
                                </div>
                                <div className={Styles.footerBottomContainerRightSocialContainer}>
                                    <div onClick={() => this._goLink("https://www.facebook.com/Swedish-Tech-Mafia-485893315247082")} className={Styles.footerBottomContainerRightSocialContainerItem}>
                                        <img className={Styles.footerBottomContainerRightSocialContainerItemFacebook} src={require("../../assets/images/facebook-logo.svg")}/>
                                    </div>
                                    <div onClick={() => this._goLink("https://www.instagram.com/swedishtechmafia")} className={Styles.footerBottomContainerRightSocialContainerItem}>
                                        <img className={Styles.footerBottomContainerRightSocialContainerItemInstagram} src={require("../../assets/images/instagram-logo.svg")}/>
                                    </div>
                                    <div onClick={() => this._goLink("https://www.linkedin.com/company/swedishtechmafia")} className={Styles.footerBottomContainerRightSocialContainerItem}>
                                        <img className={Styles.footerBottomContainerRightSocialContainerItemLinkedIn} src={require("../../assets/images/linkedin-logo.svg")}/>
                                    </div>
                                    <div onClick={() => this._goLink("https://www.twitter.com/swetechmafia")} className={Styles.footerBottomContainerRightSocialContainerItem}>
                                        <img className={Styles.footerBottomContainerRightSocialContainerItemInstagram} src={require("../../assets/images/x.svg")}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        <div className={Styles.dividerContainer}>
                            <div className={Styles.footerBottomDivider}/>
                            <div className={Styles.footerBottomInfo}>
                                <div className={Styles.footerBottomInfoLeft}>
                                    2025 © SWEDISH TECH MAFIA
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/component.js